import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const getAllCategories = async (
  organisationID = "",
  searchName = "",
  page = 1,
  pageSize = 9999,
  sort = []
) => {
  let categoryFilters = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },
  };

  const queryParams = {
    sort: sort.length > 0 ? sort : ["countNumId:desc"],
    filters: categoryFilters,
    _q: searchName,
    populate: [
      "createdByUser",
      "createdByUser.profileImage",
      "assets",
      "parts",
      "organisation",
    ],
  };

  if (page && pageSize) {
    queryParams["pagination[page]"] = String(page);
    queryParams["pagination[pageSize]"] = String(pageSize);
  }

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `categories?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    let dataObj = {
      response: the_response,
      status: response.status,
      pagination: response.data.meta.pagination,
    };
   
    return dataObj;
  } catch (err) {
    
    if (err.response) {
      return err.response.data;
      
    } else if (err.request) {
      
    } else {
      
    }
   
  }
};

